module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('span', {
    staticClass: "line"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Preface"
    }
  }, [_vm._v("Preface: From Empire to Where?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Fm02"
    }
  }, [_vm._v("Prime Ministers from 1945")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Abbreviations"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/12_Chapter01"
    }
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Environment under Strain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2.")]), _vm._v(" Economy under Strain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Changing Society")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Changing Culture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5.")]), _vm._v(" The After-Echoes of War, 1945–60")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("6.")]), _vm._v(" The Politics of Crisis, 1961–79")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("7.")]), _vm._v(" Thatcherism, 1979–90")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("8.")]), _vm._v(" Changing Directions, 1990–2016")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("9.")]), _vm._v(" British Issues, 1945–2016")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("10.")]), _vm._v(" European and World Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("11.")]), _vm._v(" Into the Future")])]), _vm._v(" "), _c('p', {
    staticClass: "tocb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("12.")]), _vm._v(" Conclusions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Further Reading")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b863104","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Contents.vue
// module id = 75
// module chunks = 0